var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { isNone, isSome } from '../common/utils/maybe';
import { ResourceRole, } from './types';
export const RESET_KEYS = [
    'slotPprRequired',
    'handling',
    'immigrationCustomsAvailable',
    'petsPermitRequired',
    'flightPlan',
    'adCategorization',
];
const findResource = (resources, role) => { var _a; return (_a = resources === null || resources === void 0 ? void 0 : resources.find((res) => res.role === role && !res.deleted)) === null || _a === void 0 ? void 0 : _a.resource; };
export function getChecklistLastConfirmation(params) {
    var _a, _b, _c, _d;
    const { checklist, checklistKey, childEvent, direction } = params;
    if (isNone(checklistKey)) {
        return undefined;
    }
    const lastConfirmation = (_a = checklist === null || checklist === void 0 ? void 0 : checklist[checklistKey]) === null || _a === void 0 ? void 0 : _a.at(-1);
    const childEventPicResourceId = (_b = findResource(childEvent === null || childEvent === void 0 ? void 0 : childEvent.resources, ResourceRole.pic)) === null || _b === void 0 ? void 0 : _b.resourceId;
    const childEventFoResourceId = (_c = findResource(childEvent === null || childEvent === void 0 ? void 0 : childEvent.resources, ResourceRole.fo)) === null || _c === void 0 ? void 0 : _c.resourceId;
    const childEventAircraftResourceId = (_d = findResource(childEvent === null || childEvent === void 0 ? void 0 : childEvent.resources, ResourceRole.aircraft)) === null || _d === void 0 ? void 0 : _d.resourceId;
    const picIsDifferent = isSome(lastConfirmation === null || lastConfirmation === void 0 ? void 0 : lastConfirmation.picResourceId) && childEventPicResourceId !== (lastConfirmation === null || lastConfirmation === void 0 ? void 0 : lastConfirmation.picResourceId);
    const foIsDifferent = isSome(lastConfirmation === null || lastConfirmation === void 0 ? void 0 : lastConfirmation.foResourceId) && childEventFoResourceId !== (lastConfirmation === null || lastConfirmation === void 0 ? void 0 : lastConfirmation.foResourceId);
    const aircraftIsDifferent = isSome(lastConfirmation === null || lastConfirmation === void 0 ? void 0 : lastConfirmation.aircraftResourceId) && childEventAircraftResourceId !== (lastConfirmation === null || lastConfirmation === void 0 ? void 0 : lastConfirmation.aircraftResourceId);
    const departureIsDifferent = isSome(lastConfirmation === null || lastConfirmation === void 0 ? void 0 : lastConfirmation.icaoFrom) && (childEvent === null || childEvent === void 0 ? void 0 : childEvent.location) !== (lastConfirmation === null || lastConfirmation === void 0 ? void 0 : lastConfirmation.icaoFrom);
    const departureIsSame = !departureIsDifferent;
    const arrivalIsDifferent = isSome(lastConfirmation === null || lastConfirmation === void 0 ? void 0 : lastConfirmation.icaoTo) && (childEvent === null || childEvent === void 0 ? void 0 : childEvent.locationEnd) !== (lastConfirmation === null || lastConfirmation === void 0 ? void 0 : lastConfirmation.icaoTo);
    const arrivalIsSame = !arrivalIsDifferent;
    let RESET = false;
    if (direction === 'departure') {
        if (departureIsDifferent) {
            RESET = true;
        }
        if (departureIsSame && arrivalIsDifferent) {
            RESET = RESET_KEYS.includes(checklistKey);
        }
    }
    else if (direction === 'arrival') {
        if (arrivalIsDifferent) {
            RESET = true;
        }
        if (arrivalIsSame && departureIsDifferent) {
            RESET = RESET_KEYS.includes(checklistKey);
        }
    }
    else {
        RESET = departureIsDifferent || arrivalIsDifferent;
    }
    if (checklistKey === 'adCategorization' && (picIsDifferent || foIsDifferent || aircraftIsDifferent)) {
        RESET = true;
    }
    return RESET ? undefined : lastConfirmation;
}
export function getDirectionFromFlagKey(params) {
    return {
        arrival_checklist_validation: 'arrival',
        departure_checklist_validation: 'departure',
        alternate1_checklist_validation: 'alternate1',
        alternate2_checklist_validation: 'alternate2',
        alternate3_checklist_validation: 'alternate3',
        fuel_axis: undefined,
        block_fuel: undefined,
        weight_tom: undefined,
        weight_lm: undefined,
        weight_zfm: undefined,
        owner_approval: undefined,
        travel_documents: undefined,
    }[params.flagKey];
}
export function isFlagLevelWorseThan(params) {
    const { level, worseThan } = params;
    switch (level) {
        case 'error': {
            return worseThan !== 'error';
        }
        case undefined: {
            return false;
        }
        case 'valid': {
            return false;
        }
        case 'warning': {
            return worseThan !== 'error' && worseThan !== 'warning';
        }
    }
}
export function findWorstLiveFlag(params) {
    var _a, _b, _c, _d;
    const now = ((_a = params.now) !== null && _a !== void 0 ? _a : new Date()).getTime();
    const activeLiveFlags = (_c = (_b = params.liveFlags) === null || _b === void 0 ? void 0 : _b.filter((live) => {
        const from = isSome(live.dateFrom) ? new Date(live.dateFrom).getTime() : undefined;
        const to = isSome(live.dateTo) ? new Date(live.dateTo).getTime() : undefined;
        if (isSome(from) && isSome(to)) {
            return now > from && now < to;
        }
        else if (isSome(from)) {
            return now > from;
        }
        else if (isSome(to)) {
            return now > to;
        }
        return false;
    })) !== null && _c !== void 0 ? _c : [];
    const errorLiveFlag = activeLiveFlags.find((liveFlag) => liveFlag.flagData.level === 'error');
    const warningLiveFlag = activeLiveFlags.find((liveFlag) => liveFlag.flagData.level === 'warning');
    const validLiveFlag = activeLiveFlags.find((liveFlag) => liveFlag.flagData.level === 'valid');
    return (_d = errorLiveFlag !== null && errorLiveFlag !== void 0 ? errorLiveFlag : warningLiveFlag) !== null && _d !== void 0 ? _d : validLiveFlag;
}
export function findWorstEventFlag(params) {
    var _a;
    const { eventFlag, flagKey, childEvent } = params;
    const { liveFlags } = eventFlag, permanentFlagData = __rest(eventFlag, ["liveFlags"]);
    const PERMANENT_FLAG = { flagData: permanentFlagData };
    const LIVE_FLAG = findWorstLiveFlag({ liveFlags: eventFlag.liveFlags, now: params.now });
    const direction = getDirectionFromFlagKey({ flagKey });
    const checklist = isSome(direction) ? (_a = childEvent === null || childEvent === void 0 ? void 0 : childEvent.checklist) === null || _a === void 0 ? void 0 : _a[direction] : undefined;
    const checklistKey = LIVE_FLAG === null || LIVE_FLAG === void 0 ? void 0 : LIVE_FLAG.flagData.checklistKey;
    const lastConfirmation = getChecklistLastConfirmation({ checklist, checklistKey, childEvent, direction });
    if ((lastConfirmation === null || lastConfirmation === void 0 ? void 0 : lastConfirmation.status) === 'confirmed' || (lastConfirmation === null || lastConfirmation === void 0 ? void 0 : lastConfirmation.status) === 'not_required') {
        return PERMANENT_FLAG;
    }
    if (isNone(LIVE_FLAG)) {
        return PERMANENT_FLAG;
    }
    const returnPermanent = isFlagLevelWorseThan({
        level: PERMANENT_FLAG.flagData.level,
        worseThan: LIVE_FLAG === null || LIVE_FLAG === void 0 ? void 0 : LIVE_FLAG.flagData.level,
    });
    const res = returnPermanent ? PERMANENT_FLAG : LIVE_FLAG;
    return res;
}
//# sourceMappingURL=checklist.js.map